module.exports = __webpack_public_path__ + "static/media/Icon2.0685f06f.webp";